import axios from "axios";
import checkIsLocalhost from "../utils/checkIsLocalhost";
import { getCookieValue } from "../utils/cookie";

const subscriptionKey = process.env.REACT_APP_API_SUBSCRIPTION_KEY;

const axiosInstance = axios.create({
  baseURL: "/",
  timeout: 90000,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const isLocalhost = checkIsLocalhost();

    config.headers.Authorization = `Bearer ${sessionStorage.getItem(
      "access_token"
    )}`;
    if (!isLocalhost) {
      config.headers["Content-Type"] = "text/plain";
      config.headers["ocp-Apim-Subscription-Key"] = subscriptionKey;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const email = getCookieValue("msal_account_email") || "";

      return axiosInstance
        .get(`/api/login?hasToken=0&email=${email}`)
        .then((response) => {
          const { accessToken } = response.data;
          axiosInstance.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
          error.config.headers.Authorization = `Bearer ${accessToken}`;
          sessionStorage.setItem("access_token", accessToken);
          return axios
            .request(error.config)
            .then((data) => Promise.resolve(data));
        });
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
